export default __webpack_public_path__ + "12f965db68dfd6ad1561a31527f08bf7.png";